import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import SocialProof from "@/components/site/SocialProof";
import HowItWorks from "@/components/site/HowItWorks";
import FundingProducts from "@/components/site/FundingProducts";
import WhyUs from "@/components/site/WhyUs";
import Industries from "@/components/site/Industries";
import Calculator from "@/components/site/Calculator";
import ApprovalQuiz from "@/components/site/ApprovalQuiz";
import Testimonials from "@/components/site/Testimonials";
import LeadForm from "@/components/site/LeadForm";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import LiveChatMockup from "@/components/site/LiveChatMockup";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-[#050B14] text-white">
      <Header />
      <Hero />
      <SocialProof />
      <HowItWorks />
      <FundingProducts />
      <WhyUs />
      <Industries />
      <Calculator />
      <ApprovalQuiz />
      <Testimonials />
      <LeadForm />
      <FAQ />
      <FinalCTA />
      <Footer />
      <LiveChatMockup />
      <StickyMobileCTA />
    </main>
  );
}
